import * as React from 'react';

const ChevronUpSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M12 8l-7 7 .7.7L12 9.4l6.3 6.3.7-.7z"
        />
    </svg>
);

ChevronUpSvg.displayName = 'ChevronUpSvg';
export default ChevronUpSvg;
